<template>
  <el-form
    ref="checkListForm"
    label-width="150px"
    :model="checkListForm"
    :disabled="formProps.editType === 'read'"
    class="pt-20px px-20px"
  >
    <el-row>
      <el-form-item
        label="隐患排查内容"
        prop="screeningContent"
        :rules="[{ required: true, message: '请填写隐患排查内容', trigger: ['change', 'blur'] }]"
      >
        <el-input
          v-model="checkListForm.screeningContent"
          type="textarea"
          :rows="3"
          maxlength="200"
          show-word-limit
          placeholder="请填写隐患排查内容"
        ></el-input>
      </el-form-item>
    </el-row>
    <div class="flex">
      <el-form-item
        label="隐患排查周期"
        prop="inspectionCycle"
        :rules="[{ required: true, message: '请填写隐患排查周期', trigger: ['change', 'blur'] }]"
      >
        <el-input-number
          controls-position="right"
          :min="1"
          :precision="0"
          placeholder=""
          v-model="checkListForm.inspectionCycle"
          size="small"
          clearable
        ></el-input-number>
      </el-form-item>

      <el-form-item
        label="单位周期"
        prop="unitCycle"
        :rules="[{ required: true, message: '请填写单位周期', trigger: ['change', 'blur'] }]"
      >
        <el-select placeholder="请输入单位周期" v-model="checkListForm.unitCycle" clearable>
          <el-option
            v-for="item in unitCycleList"
            :key="item.code"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="排查类型"
        prop="screeningType"
        :rules="[{ required: true, message: '请填写排查类型', trigger: ['change', 'blur'] }]"
      >
        <el-select placeholder="请输入排查类型" v-model="checkListForm.screeningType" clearable>
          <el-option
            v-for="item in checkTypeList"
            :key="item.code"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-button class="ml-10px !mt-6px" size="mini" @click="clear">清除</el-button>
    </div>
  </el-form>
</template>

<script>
import utils from '@/components/safety/enumField/utils'

export default {
  name: 'check-list-form',
  components: {},
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      unitCycleList: [],
      checkTypeList: [],
      checkListForm: {},
    }
  },
  computed: {},
  watch: {},
  created() {
    this.checkListForm = JSON.parse(JSON.stringify(this.formData))
  },
  mounted() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.UnitCycle',
        'DoublePreventionManagement.DataCategory.CheckType',
      ],
      ['unitCycleList', 'checkTypeList'],
      this
    )
  },
  methods: {
    clear() {
      this.checkListForm.inspectionCycle = ''
      this.checkListForm.unitCycle = ''
      this.checkListForm.screeningType = ''
    },
    validateData() {
      let form = false
      this.$refs.checkListForm.validate((valid) => {
        if (valid) {
          form = this.checkListForm
        }
      })
      return form
    },
  },
}
</script>

<style scoped lang="scss"></style>
